import { render } from "./OwnTree.vue?vue&type=template&id=66ba32d2"
import script from "./OwnTree.vue?vue&type=script&lang=js"
export * from "./OwnTree.vue?vue&type=script&lang=js"

import "./OwnTree.vue?vue&type=style&index=0&id=66ba32d2&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__